export const Loading = () => {
  return <div className="flex h-screen w-screen items-center justify-center">Loading...</div>;
};
